<!--begin::Topbar-->
<div class="topbar mt-5">
    <div class="topbar-item" *ngIf="champSession.userId">
        <button class="btn btn-hover-transparent-white btn-sm" style="border: 1px solid #b92626; margin-right:15px;"
            (click)="loadTree()">
            {{this.selectedType?.baselineName == null || undefined ? content?.selectBaseline :
            this.selectedType?.baselineName}}
            {{ (this.selectedType?.type==2) ? ' / ' + this.selectedType?.simulationName : '' }}
        </button>
    </div>
    <app-right-side-tree width="100%" *ngIf="toggleTree"></app-right-side-tree>
    <!--begin::User-->
    <div class="topbar-item" *ngIf="!champSession.userId">
        <select (change)="selectUser($event)">
            <option>{{commonContent?.select}}</option>
            <option *ngFor="let item of userList" value="{{item.userId}}">
                {{item.userId}}
            </option>
        </select>
    </div>
    <div class="topbar-item" *ngIf="champSession.userId">
        <div class="card-toolbar">
            <div class="dropdown dropdown-inline">
                <a href="#" class="gray">
                    {{champSession.userEmail}}                   
                </a> &nbsp;&nbsp;
                <a href="#" class="gray" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    (click)="showPopup()">
                    <span class="navi-icon">
                        <img src="assets/flag/{{champSession.language}}.png">
                    </span>
                    
                </a>
                <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                    <!--begin::Navigation-->
                    <ul class="navi navi-hover">
                        <li class="navi-item">
                            <ul class="navi">
                                <li class="navi-item">
                                    <a class="navi-link" (click)="funcLangPopup('en')">
                                        <span class="navi-icon">
                                            <img src="assets/flag/en.png">
                                        </span>&nbsp;&nbsp;
                                        <span class="navi-text">{{commonContent?.langEng}}</span>
                                    </a>
                                </li>
                                <li class="navi-item">
                                    <a class="navi-link" (click)="funcLangPopup('fr')">
                                        <span class="navi-icon">
                                            <img src="assets/flag/fr.png">
                                        </span>&nbsp;&nbsp;
                                        <span class="navi-text">{{commonContent?.langrench}}</span>
                                    </a>
                                </li>
                                <li class="navi-item">
                                    <a class="navi-link" (click)="funcLangPopup('es')">
                                        <span class="navi-icon">
                                            <img src="assets/flag/es.png">
                                        </span>&nbsp;&nbsp;
                                        <span class="navi-text">{{commonContent?.langSpanish}}</span>
                                    </a>
                                </li>
                                <li class="navi-item">
                                    <a class="navi-link" (click)="funcLangPopup('cn')">
                                        <span class="navi-icon">
                                            <img src="assets/flag/cn.png">
                                        </span> &nbsp;&nbsp;
                                        <span class="navi-text">{{commonContent?.langChina}}</span>
                                    </a>
                                </li>
                            </ul>
                        <!-- </li>
                        <li class="navi-item">
                            <a (click)='logout()' class="navi-link">
                                <span class="navi-icon">
                                    <i class="flaticon2-calendar-8"></i>
                                </span>
                                <span class="navi-text">{{commonContent?.logout}}</span>
                            </a>
                        </li> -->
                    </ul>
                    <!--end::Navigation-->
                </div>
            </div>
        </div>
    </div>
    <!--end::User-->
</div>
<!--end::Topbar-->